export default "/images/30e86c5e4b4c544ff9ce9b7555af26e7.avif";